import { httpService, urlService } from 'core-utilities';
import urlConstant from '../constants/urlConstants';
import serverListConstants from '../constants/serverListConstants';

const { serverListTypes } = serverListConstants;

const {
  getGameServersUrl,
  getShutdownGameInstanceUrl,
  getVipServerUrl,
  createVipServerUrl,
  createPrivateServerUrl,
  updateVipServerSubscriptionUrl
} = urlConstant;

export default {
  getPublicGameInstances: (placeId, cursor) => {
    const urlConfig = {
      url: getGameServersUrl(placeId, serverListTypes.public.value),
      retryable: true,
      withCredentials: true
    };
    const params = {};
    if (cursor) {
      params.cursor = cursor;
    }
    return httpService.get(urlConfig, params);
  },
  getFriendsGameInstances: (placeId, cursor) => {
    const urlConfig = {
      url: getGameServersUrl(placeId, serverListTypes.friend.value),
      retryable: true,
      withCredentials: true
    };
    const params = {};
    if (cursor) {
      params.cursor = cursor;
    }
    return httpService.get(urlConfig, params);
  },
  getVipGameInstances: (placeId, cursor) => {
    const urlConfig = {
      url: getGameServersUrl(placeId, serverListTypes.Vip.value),
      retryable: true,
      withCredentials: true
    };
    return httpService.get(urlConfig, { cursor });
  },

  shutdownGameInstance: (placeId, gameId, privateServerId) => {
    const requestVerificationToken = document.getElementsByName('__RequestVerificationToken')[0]
      ?.value;

    const urlConfig = {
      url: getShutdownGameInstanceUrl(),
      retryable: true,
      withCredentials: true
    };

    const data = {
      __RequestVerificationToken: requestVerificationToken,
      placeId,
      gameId
    };

    if (privateServerId) {
      data.privateServerId = privateServerId;
    }

    return httpService.post(urlConfig, data);
  },
  createPrivateServer: params => {
    const requestVerificationToken = document.getElementsByName('__RequestVerificationToken')[0]
      ?.value;

    const urlConfig = {
      url: createPrivateServerUrl(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      retryable: true,
      withCredentials: true
    };

    const data = {
      __RequestVerificationToken: requestVerificationToken,
      ...params
    };

    return httpService.post(urlConfig, urlService.composeQueryString(data));
  },
  getVipServer: vipServerId => {
    const urlConfig = {
      url: getVipServerUrl(vipServerId),
      retryable: true,
      withCredentials: true
    };
    return httpService.get(urlConfig);
  },
  createVipServer: (universeId, name, expectedPrice) => {
    const urlConfig = {
      url: createVipServerUrl(universeId),
      retryable: true,
      withCredentials: true
    };
    return httpService.post(urlConfig, { name, expectedPrice });
  },
  updateVipServerSubscription: (vipServerId, active, price) => {
    const urlConfig = {
      url: updateVipServerSubscriptionUrl(vipServerId),
      retryable: true,
      withCredentials: true
    };
    return httpService.patch(urlConfig, { active, price });
  }
};
